import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PaginationSettings } from '../models/paginationsettings';
import { BirthdayStatsVisitorDataOutputDTO } from '../models/birthdayStatsVisitorDataOutputDTO';

@Injectable({
  providedIn: 'root'
})
export class BirthdayListService {


  private birthdaySource = new ReplaySubject<any[]>(1);
  birthdays$ = this.birthdaySource.asObservable();


  private birthdayPaginationSource = new ReplaySubject<any>(1);
  birthdayPagination$ = this.birthdayPaginationSource.asObservable();

  apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }


  getAllBirthday(queryParams: any = {
    currentPage: null,
    itemsPerPage: null,
    VisitorIdQuery: null,
    cityQuery: '', roomNameQuery: '', birthdayZoneNameQuery: '', VisitorNameQuery: '', CallDateFromQuery: '',
    CallDateToQuery: '', AppointmentDateFromQuery: '', AppointmentDateToQuery: '', PricePerChildrenFromQuery: '',
    PricePerChildrenToQuery: '',
    PlannedChildNumberFromQuery: '', PlannedChildNumberToQuery: '',
    PresentChildNumberFromQuery: '', PresentChildNumberToQuery: '', TotalPricePaidFromQuery: '',
    TotalPricePaidToQuery: '', StatusCallQuery: '', NumberOfBirthdayFromQuery: '', NumberOfBirthdayToQuery: '',
    AdvancePaymentWillQuery: '', AdvancePricePaidFromQuery: '', AdvancePricePaidToQuery: ''
  }) {

    const currentPage = queryParams.currentPage ?? 1;
    const itemsPerPage = queryParams.itemsPerPage ?? 10;
    const visitorIdQuery = queryParams.VisitorIdQuery ?? queryParams.visitorIdQuery;

    let params = new HttpParams()
      .append('pageNumber', currentPage.toString())
      .append('pageSize', itemsPerPage.toString());

    if (visitorIdQuery !== undefined && visitorIdQuery !== null && visitorIdQuery !== '') {
      params = params.append('VisitorIdQuery', String(visitorIdQuery));
    }

    const allFilters = [
      'cityQuery', 'roomNameQuery', 'birthdayZoneNameQuery', 'VisitorNameQuery',
      'CallDateFromQuery', 'CallDateToQuery', 'PricePerChildrenFromQuery', 'PricePerChildrenToQuery',
      'AppointmentDateFromQuery', 'AppointmentDateToQuery',
      'PlannedChildNumberFromQuery', 'PlannedChildNumberToQuery', 'PresentChildNumberFromQuery', 'PresentChildNumberToQuery',
      'TotalPricePaidFromQuery', 'TotalPricePaidToQuery', 'StatusCallQuery',
      'NumberOfBirthdayFromQuery', 'NumberOfBirthdayToQuery', 'AdvancePaymentWillQuery',
      'AdvancePricePaidFromQuery', 'AdvancePricePaidToQuery'
    ];

    for (const key of allFilters) {
      if (queryParams[key] !== undefined && queryParams[key] !== null && queryParams[key] !== '') {
        params = params.append(key, queryParams[key]);
      }
    }
    
    return this.http.get(this.apiUrl + 'Rodjendan/SearchBirthdays', { params, observe: 'response' })
      .pipe(
        map((res: any) => {
          if (!res) return;

          const pag = res.headers.get('pagination');
          if (pag) {
            try {
              const parsed = JSON.parse(pag);


              const normalized: PaginationSettings = {
                totalItems: parsed.totalItems ?? 0,
                currentPage: parsed.curentPage ?? parsed.currentPage ?? 1,
                itemsPerPage: parsed.itemsPerPage ?? 10
              };


              this.birthdayPaginationSource.next({ ...normalized });
            } catch (err) {
              console.error('Greška u parsiranju pagination header-a:', err);
            }
          }


          if (Array.isArray(res.body)) {
            this.birthdaySource.next([...res.body]);
          } else {
            console.warn('Neočekivan format response body:', res.body);
            this.birthdaySource.next([]);
          }

          return res.body;
        })
      )
      .toPromise();
  }


  editBirthdayList(dto, id) {

    return this.http.put(`${this.apiUrl}Rodjendan/${id}`, dto);

  }
  editBirthdayDissmisList(birthdayDismissList) {
    console.log('EIDIT birth', birthdayDismissList)
    return this.http.put(`${this.apiUrl}Rodjendan/${birthdayDismissList.id}/dismissBirthday`, birthdayDismissList);

  }


  deleteBirthday(id) {
    return this.http.delete(`${this.apiUrl}Rodjendan/${id}`);
  }

  exportCSV(queryParams = {
    currentPage: 1, itemsPerPage: 20, pageSize: 2147483647, cityQuery: '', roomNameQuery: '', birthdayZoneNameQuery: '', VisitorNameQuery: '',
    CallDateFromQuery: '', PricePerChildrenFromQuery: '',
    PricePerChildrenToQuery: '',
    CallDateToQuery: '', AppointmentDateFromQuery: '', AppointmentDateToQuery: '', PlannedChildNumberFromQuery: '', PlannedChildNumberToQuery: '',
    PresentChildNumberFromQuery: '', PresentChildNumberToQuery: '', TotalPricePaidFromQuery: '',
    TotalPricePaidToQuery: '', StatusCallQuery: ''
  }) {
    let params = new HttpParams();
    params = params.append('cityQuery', queryParams.cityQuery);
    params = params.append('roomNameQuery', queryParams.roomNameQuery);
    params = params.append('birthdayZoneNameQuery', queryParams.birthdayZoneNameQuery);
    params = params.append('VisitorNameQuery', queryParams.VisitorNameQuery);
    params = params.append('PricePerChildrenFromQuery', queryParams.PricePerChildrenFromQuery);
    params = params.append('PricePerChildrenToQuery', queryParams.PricePerChildrenToQuery);
    params = params.append('CallDateFromQuery', queryParams.CallDateFromQuery);
    params = params.append('CallDateToQuery', queryParams.CallDateToQuery);
    params = params.append('AppointmentDateFromQuery', queryParams.AppointmentDateFromQuery);
    params = params.append('AppointmentDateToQuery', queryParams.AppointmentDateToQuery);
    params = params.append('PlannedChildNumberFromQuery', queryParams.PlannedChildNumberFromQuery);
    params = params.append('PlannedChildNumberToQuery', queryParams.PlannedChildNumberToQuery);
    params = params.append('PresentChildNumberFromQuery', queryParams.PresentChildNumberFromQuery);
    params = params.append('PresentChildNumberToQuery', queryParams.PresentChildNumberToQuery);
    params = params.append('TotalPricePaidFromQuery', queryParams.TotalPricePaidFromQuery);
    params = params.append('TotalPricePaidToQuery', queryParams.TotalPricePaidToQuery);
    params = params.append('StatusCallQuery', queryParams.StatusCallQuery);
    return this.http.get(this.apiUrl + 'Rodjendan/exportCSV', { params, responseType: "text" })
  }

  getReportByVisitors(queryParams: {
    currentPage: number;
    itemsPerPage: number;
    VisitorNameQuery?: string;
  }) {
    return this.http.post<any>(
      this.apiUrl + 'Rodjendan/statsVisitors',
      {
        pageNumber: queryParams.currentPage,
        pageSize: queryParams.itemsPerPage,
        VisitorNameQuery: queryParams.VisitorNameQuery
      },
      { observe: 'response' }
    );
  }

getReportByRoomAverageBirthday(
queryParams: {
   
    roomNameQuery?: string;
  }){
 return this.http.post<any>(
      this.apiUrl + 'Rodjendan/statsRooms',
      {
        
        RoomNameQuery : queryParams.roomNameQuery
      },
      { observe: 'response' }
    );

}

BirthdayVisitorReportExportCSV(queryParams: {
  currentPage: number;
  itemsPerPage: number;
  pageSize: number;
  VisitorNameQuery?: string;
}) {
  return this.http.post(
    this.apiUrl + 'Rodjendan/exportStatsVisitorBirthdayCSV',
    {
      currentPage: queryParams.currentPage,
      itemsPerPage: queryParams.itemsPerPage,
      pageSize: queryParams.pageSize,
      VisitorNameQuery: queryParams.VisitorNameQuery
    },
    {
      responseType: 'blob'   
    }
  );
}



BirthdayRoomAverageReportExportCSV(
queryParams: {
   
    roomNameQuery?: string;
  }

)

{

 return this.http.post(
    this.apiUrl + 'Rodjendan/exportStatsRoomBirthdayAverageCSV',
    {
     
      RoomNameQuery: queryParams.roomNameQuery
    },
    {
      responseType: 'blob'   
    }
  );


}

getScheduledByOperatorReport(queryParams: {
  cityQuery?: string;
  roomNameQuery?: string;
  birthdayZoneNameQuery?: string;
  callDateFromQuery?: string;
  callDateToQuery?: string;
  appointmentDateFromQuery?: string;
  appointmentDateToQuery?: string;
  employeeIdQuery?: number | null;
}) {
  return this.http.post<any>(
    this.apiUrl + 'Rodjendan/statsScheduledByOperator',
    {
      CityQuery: queryParams.cityQuery,
      RoomNameQuery: queryParams.roomNameQuery,
      BirthdayZoneNameQuery: queryParams.birthdayZoneNameQuery,
      CallDateFromQuery: queryParams.callDateFromQuery,
      CallDateToQuery: queryParams.callDateToQuery,
      AppointmentDateFromQuery: queryParams.appointmentDateFromQuery,
      AppointmentDateToQuery: queryParams.appointmentDateToQuery,
      EmployeeIdQuery: queryParams.employeeIdQuery
    },
    { observe: 'response' }
  );
}

exportScheduledByOperatorReportCSV(queryParams: {
  cityQuery?: string;
  roomNameQuery?: string;
  birthdayZoneNameQuery?: string;
  callDateFromQuery?: string;
  callDateToQuery?: string;
  appointmentDateFromQuery?: string;
  appointmentDateToQuery?: string;
  employeeIdQuery?: number | null;
}) {
  return this.http.post(
    this.apiUrl + 'Rodjendan/exportStatsScheduledByOperatorCSV',
    {
      CityQuery: queryParams.cityQuery,
      RoomNameQuery: queryParams.roomNameQuery,
      BirthdayZoneNameQuery: queryParams.birthdayZoneNameQuery,
      CallDateFromQuery: queryParams.callDateFromQuery,
      CallDateToQuery: queryParams.callDateToQuery,
      AppointmentDateFromQuery: queryParams.appointmentDateFromQuery,
      AppointmentDateToQuery: queryParams.appointmentDateToQuery,
      EmployeeIdQuery: queryParams.employeeIdQuery
    },
    {
      responseType: 'blob'
    }
  );
}
}
